<template>
  <div
    :class="'bg-'+mainClass"
    class="text-red-100 py-0 px-6 shadow md:flex justify-between items-center"
  >
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css"
    />

    <div class="flex items-center cursor-pointer" >
      <span class="text-green-500 text-x1 mr-1 mt-0 mb-0"> </span>
      <div id="appp">
        <a href="/"><img class="min-h-[78px] object-contain" :src="'/images/logo'+mainClass+'.png'" width="150"></a>
      </div>
    </div>
    <span
      @click="Menuopen()"
      class="absolute right-1 top-4.5 cursor-poinet text-4xl text-white z-1000"
    >
      <i :class="[open ? 'bi bi-x' : 'bi bi-filter-right']"></i>
    </span>
    <ul
      class="
        md:flex md:items-center md:px-02
        pr-0
        pb-2  
        py-2    
        mr-10  
        absolute
        md:w-auto
        w-full
        duration-700
        ease-in
        text-white
      "
      :class="[open ? 'relative' : 'left-[-100%]']"
    >
      <li class="md:mx-4" v-show="!login">
        <a href="/cuenta" class="text-x1 hover:text-[#822c30]">Mi cuenta</a>
      </li>
      <li class="md:mx-4" v-show="login">
        <a href="/login" class="text-x1 hover:text-[#822c30]" >Iniciar Sesión</a>
      </li>
      <li class="md:mx-4"  v-show="login">
        <a href="/registrate" class="text-x1 hover:text-[#822c30]" >Regístrate</a>
      </li>
       <li class="md:mx-4">
        <a href="/" class="text-x1 hover:text-[#822c30]" >Comprar Boletos</a>
      </li>
      <li class="md:mx-4"  v-show="login">
        <a href="/busqueda" class="text-x1 hover:text-[#822c30]" >Facturar</a>
      </li>
       <li class="md:mx-4"  v-show="logout" style="cursor:pointer;"  @click="cerarSesion(); ">
        <a  class="text-x1 " :class="'hover:text-btn-'+mainClass">Cerrar Sesión</a>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="less">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

#appp {
  font-family: "Montserrat";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 23px;

  color: #ffffff;
  font-weight: bold;
}
</style>
<script>
import { ref } from "vue";
export default {
    computed: {
        mainClass() {
          return process.env.VUE_APP_COLOR;
        }
      },
  props: {
    logueado: { required: false },
  },
  data: function () {
    return {
      logout: false,
      login: true,
    }
  },
   mounted(){
    const logueado = localStorage.getItem('access_token')
    if(logueado === 'null' || logueado === null) {
      this.logout = false;
      this.login = true;
    } else {
      this.logout = true;
      this.login = false;
      
    }
    }, 
    watch: {
      logueado: {
        handler: "checkLogueado",
        immediate: false,
        deep: true,
      },

    },

  
  setup() {
    var open = ref(false);
    function Menuopen() {
      const logueado = localStorage.getItem('access_token')
      /*
      if(logueado === null) {
        this.logout = true;
        this.login = false;
      } else {
        this.logout = false;
        this.login = true;
      }*/
      open.value = !open.value;
    }
    
    return { open, Menuopen };
  },
  methods: {
    checkLogueado(){
      if(this.logueado) {
        this.logout = true;
        this.login = false;
      } else {
        this.logout = false;
        this.login = true;
      }
    },
    cerarSesion() {
      localStorage.clear();
      if(localStorage.getItem('access_token')) {
        this.logout = true;
        this.login = false;
      } else {
        this.logout = false;
        this.login = true;
      }
      this.$router.push("/");
    },    
  }
};
</script>
<style src="./assets/tailwind.css"/>




